export { default } from './StatusPicker.vue'
